import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-subscription',
  templateUrl: './client-subscription.component.html',
  styleUrls: ['./client-subscription.component.scss']
})
export class ClientSubscriptionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
